export const OrderConfirmation = () => {
	return (
		<svg width='188' height='188' viewBox='0 0 188 188' fill='none' xmlns='http://www.w3.org/2000/svg'>
			{/* <g filter='url(#filter0_d_0_25)'> */}
			<g>
				<mask
					id='mask0_0_25'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='104'
					y='125'
					width='49'
					height='14'
				>
					<rect x='104' y='125' width='49' height='14' fill='white' />
				</mask>
				<g mask='url(#mask0_0_25)'>
					<path
						d='M133.695 152.06L130.617 160.517C127.972 167.783 119.938 171.529 112.673 168.884C105.407 166.24 101.661 158.206 104.305 150.94L107.383 142.483C110.028 135.217 118.062 131.471 125.327 134.116C132.593 136.76 136.339 144.794 133.695 152.06Z'
						fill='#CAE0EC'
						stroke='#00AAE8'
						strokeWidth='2'
					/>
					<path
						d='M146.695 149.06L143.617 157.517C140.972 164.783 132.938 168.529 125.673 165.884C118.407 163.24 114.661 155.206 117.305 147.94L120.383 139.483C123.028 132.217 131.062 128.471 138.327 131.116C145.593 133.76 149.339 141.794 146.695 149.06Z'
						fill='#E8F3F9'
						stroke='#00AAE8'
						strokeWidth='2'
					/>
				</g>
				<rect x='55.5' y='139.5' width='99' height='1' stroke='#00AAE8' />
				<circle cx='94' cy='90' r='90' fill='#F9F9F9' />
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M168.845 140C178.417 125.699 184 108.501 184 90C184 40.2944 143.706 0 94 0C44.2944 0 4 40.2944 4 90C4 108.501 9.58272 125.699 19.1555 140H168.845Z'
					fill='#E8F3F9'
				/>
				<mask
					id='mask1_0_25'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='104'
					y='125'
					width='49'
					height='14'
				>
					<rect x='104' y='125' width='49' height='14' fill='white' />
				</mask>
				<g mask='url(#mask1_0_25)'>
					<path
						d='M133.695 152.06L130.617 160.517C127.972 167.783 119.938 171.529 112.673 168.884C105.407 166.24 101.661 158.206 104.305 150.94L107.383 142.483C110.028 135.217 118.062 131.471 125.327 134.116C132.593 136.76 136.339 144.794 133.695 152.06Z'
						fill='#CAE0EC'
						stroke='#00AAE8'
						strokeWidth='2'
					/>
					<path
						d='M146.695 149.06L143.617 157.517C140.972 164.783 132.938 168.529 125.673 165.884C118.407 163.24 114.661 155.206 117.305 147.94L120.383 139.483C123.028 132.217 131.062 128.471 138.327 131.116C145.593 133.76 149.339 141.794 146.695 149.06Z'
						fill='#E8F3F9'
						stroke='#00AAE8'
						strokeWidth='2'
					/>
				</g>
				<mask id='path-10-inside-1_0_25' fill='white'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M106.883 21.0106C102.385 25.7402 102.062 33.1965 106.356 38.3148C110.971 43.8148 119.171 44.5322 124.671 39.9172C125.269 39.4154 125.81 38.8712 126.295 38.2928C124.137 37.2966 119.186 34.7857 115 31C111.23 27.5908 108.287 23.261 106.883 21.0106Z'
					/>
				</mask>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M106.883 21.0106C102.385 25.7402 102.062 33.1965 106.356 38.3148C110.971 43.8148 119.171 44.5322 124.671 39.9172C125.269 39.4154 125.81 38.8712 126.295 38.2928C124.137 37.2966 119.186 34.7857 115 31C111.23 27.5908 108.287 23.261 106.883 21.0106Z'
					fill='white'
				/>
				<path
					d='M106.883 21.0106L108.58 19.9518L107.213 17.7614L105.434 19.6323L106.883 21.0106ZM106.356 38.3148L107.888 37.0292L107.888 37.0292L106.356 38.3148ZM124.671 39.9172L125.957 41.4492L125.957 41.4492L124.671 39.9172ZM126.295 38.2928L127.828 39.5766L129.506 37.5726L127.133 36.477L126.295 38.2928ZM115 31L116.341 29.5166L116.341 29.5166L115 31ZM105.434 19.6323C100.242 25.091 99.8678 33.6936 104.824 39.6004L107.888 37.0292C104.255 32.6994 104.527 26.3893 108.332 22.3888L105.434 19.6323ZM104.824 39.6004C110.149 45.9465 119.611 46.7743 125.957 41.4492L123.385 38.3851C118.732 42.2901 111.793 41.6831 107.888 37.0292L104.824 39.6004ZM125.957 41.4492C126.645 40.8718 127.269 40.2445 127.828 39.5766L124.761 37.009C124.352 37.498 123.893 37.959 123.385 38.3851L125.957 41.4492ZM127.133 36.477C125.045 35.5131 120.307 33.1027 116.341 29.5166L113.659 32.4834C118.066 36.4688 123.229 39.0801 125.456 40.1086L127.133 36.477ZM116.341 29.5166C112.776 26.2924 109.949 22.1465 108.58 19.9518L105.186 22.0693C106.625 24.3754 109.684 28.8891 113.659 32.4834L116.341 29.5166Z'
					fill='#00AAE8'
					mask='url(#path-10-inside-1_0_25)'
				/>
				<circle cx='125' cy='49' r='1' fill='#E8F3F9' stroke='#00AAE8' />
				<circle cx='115.5' cy='16.5' r='1.5' fill='#00AAE8' />
				<circle cx='93' cy='20' r='1' fill='#00AAE8' />
				<rect x='125' y='28' width='3' height='1' rx='0.5' fill='#00AAE8' />
				<rect x='127' y='27' width='3' height='1' rx='0.5' transform='rotate(90 127 27)' fill='#00AAE8' />
				<rect x='96' y='37' width='3' height='1' rx='0.5' fill='#00AAE8' />
				<rect x='98' y='36' width='3' height='1' rx='0.5' transform='rotate(90 98 36)' fill='#00AAE8' />
				<rect x='37.5' y='139.5' width='130' height='1' stroke='#00AAE8' />
				<rect x='20.5' y='139.5' width='11' height='1' stroke='#00AAE8' />
				<rect x='95' y='69' width='34' height='34' fill='white' stroke='#00AAE8' strokeWidth='2' />
				<path fillRule='evenodd' clipRule='evenodd' d='M97 71H107V81H97V71Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M107 81H117V91H107V81Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M97 91H107V101H97V91Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M117 91H127V101H117V91Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M117 71H127V81H117V71Z' fill='#00AAE8' />
				<path d='M61 62V139' stroke='#00AAE8' strokeWidth='2' strokeLinecap='square' />
				<circle cx='61' cy='56' r='3' fill='#CAE0EC' stroke='#00AAE8' strokeWidth='2' />
				<rect x='64' y='62' width='34' height='34' fill='white' stroke='#00AAE8' strokeWidth='2' />
				<path fillRule='evenodd' clipRule='evenodd' d='M66 64H76V74H66V64Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M76 74H86V84H76V74Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M66 84H76V94H66V84Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M86 84H96V94H86V84Z' fill='#00AAE8' />
				<path fillRule='evenodd' clipRule='evenodd' d='M86 64H96V74H86V64Z' fill='#00AAE8' />
				<circle cx='35' cy='36' r='19' fill='#89C947' stroke='#DBF2C3' strokeWidth='5' />
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M33.4034 45.3617L25.7198 37.68L29.079 34.3208L32.7973 38.0391L40.6671 27.021L44.5317 29.7798L33.4034 45.3617Z'
					fill='white'
				/>
			</g>
			{/* <defs>
				<filter
					id='filter0_d_0_25'
					x='0'
					y='0'
					width='188'
					height='188'
					filterUnits='userSpaceOnUse'
					colorInterpolationFilters='sRGB'
				>
					<feFlood floodOpacity='0' result='BackgroundImageFix' />
					<feColorMatrix
						in='SourceAlpha'
						type='matrix'
						values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
						result='hardAlpha'
					/>
					<feOffset dy='4' />
					<feGaussianBlur stdDeviation='2' />
					<feComposite in2='hardAlpha' operator='out' />
					<feColorMatrix type='matrix' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0' />
					<feBlend mode='normal' in2='BackgroundImageFix' result='effect1_dropShadow_0_25' />
					<feBlend mode='normal' in='SourceGraphic' in2='effect1_dropShadow_0_25' result='shape' />
				</filter>
			</defs> */}
		</svg>
	);
};
